import { Box } from '@chakra-ui/react'
import './ProgressBar.css'

export default function ProgressBar() {
  return (
    <div className='container'>
      <div className='progressBar'>
        <Box bg="secondary" className='progressSegment'></Box>
      </div>
    </div>
  )
}